module.exports = __webpack_public_path__ + "img/014.c629bdb2.jpeg";